'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTimestampLessThanOneDayAgo = isTimestampLessThanOneDayAgo;
exports.isFutureTimestamp = isFutureTimestamp;
exports.isTimestampThisYear = isTimestampThisYear;
exports.getDateFormatWithYear = getDateFormatWithYear;
exports.getDateFormatWithoutYear = getDateFormatWithoutYear;
exports.getTimeAgoDate = getTimeAgoDate;
exports.getDateString = getDateString;
exports.getI18nDateMessage = getI18nDateMessage;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DAY_IN_MS = 1000 * 60 * 60 * 24;

function isTimestampLessThanOneDayAgo(messageTimetamp) {
  return _I18n2.default.moment().diff(messageTimetamp) < DAY_IN_MS;
}

function isFutureTimestamp(messageTimestamp) {
  return messageTimestamp.diff(_I18n2.default.moment()) > 0;
}

function isTimestampThisYear(messageTimetamp) {
  return messageTimetamp.get('year') === _I18n2.default.moment().get('year');
}

function getDateFormatWithYear(messageTimestamp) {
  return messageTimestamp.format('MMM Do YYYY, h:mm A');
}

function getDateFormatWithoutYear(messageTimestamp) {
  return messageTimestamp.format('MMM Do, h:mm A');
}

function getTimeAgoDate(messageTimestamp) {
  if (isFutureTimestamp(messageTimestamp)) {
    return _I18n2.default.moment().fromNow();
  }

  return messageTimestamp.fromNow();
}

function getDateString(messageTimetamp) {
  if (isTimestampLessThanOneDayAgo(messageTimetamp)) {
    return getTimeAgoDate(messageTimetamp);
  }
  if (isTimestampThisYear(messageTimetamp)) {
    return getDateFormatWithoutYear(messageTimetamp);
  }
  return getDateFormatWithYear(messageTimetamp);
}

function getI18nDateMessage(messageTimetamp) {
  var withinOneDay = isTimestampLessThanOneDayAgo(messageTimetamp);
  var dateString = getDateString(messageTimetamp);

  if (withinOneDay) {
    return dateString;
  }

  return _I18n2.default.text('conversationsUI.chat.dateStringWithOn', { dateString: dateString });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/utils/labelDateUtils.js
// module id = 1149
// module chunks = 2 3